import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  EnterpriseBasketService,
  ServiceType,
  FastTrackQuote,
  EnterpriseSearchService,
  UserService,
  ModalOpenerService
} from '@sabstravtech/obtservices/angular';
import {
  FastTrackEnterpriseSearchInterface,
  FlightEnterpriseSearchInterface
} from '@sabstravtech/obtservices/base';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

import { BaseSearchComponent } from '../../../core/components/base-search/base-search.component';
import { LightningModalTypes } from '../../../core/classes/modal-types.enum';
import { FlightPipe } from '../../../startup/pipes/flight-pipe';
import { resultIcons } from '../../../core/enum/result-icons.enum';
import { ThemeService } from '../../../core/services/theme.service';

@Component({
  selector: 'app-fast-track',
  templateUrl: './fast-track.component.html',
  styleUrls: ['./fast-track.component.scss'],
  standalone: false
})
export class FastTrackComponent extends BaseSearchComponent implements OnInit {
  public ServiceType: typeof ServiceType = ServiceType;
  mapView = false;
  itemPhotos = false;
  resultItemType = resultIcons;
  public searchParams: FastTrackEnterpriseSearchInterface = null;
  canOverride = false;
  public flightSearchParams: FlightEnterpriseSearchInterface;
  displayItinerary = false;

  constructor(
    public searchService: EnterpriseSearchService,
    public userService: UserService,
    private route: ActivatedRoute,
    private basketService: EnterpriseBasketService,
    private modalService: ModalOpenerService,
    protected flightPipe: FlightPipe,
    public translateService: TranslateService,
    public title: Title,
    public themeService: ThemeService
  ) {
    super(searchService);
    this.flightSearchParams = searchService.searches[ServiceType.Flight];
    this.title.setTitle(
      this.translateService.instant(
        `Fast Track Results ${this.themeService.isLightningEnv ? ' - LightUk' : ''}`
      )
    );
  }

  ngOnInit(): void {
    this.canOverride = this.userService.canOverride();
    this.searchParams = this.searchService.searches[ServiceType.FastTrack];
    this.subscribe(this.route.queryParams, ({ center }) => {
      this.mapView = !!center;
    });

    this.subscribe(this.route.data, ({ type }) => {
      console.log(`Detected search type: ${type}`, 'PNL');
    });
    this.displayItinerary = this.userService.isBasketReplacementUserFavouriteSet();
  }

  toggleItemDetails(
    item: FastTrackQuote & {
      showDetails: boolean;
    }
  ): void {
    item.showDetails = !item.showDetails;
  }

  toggleItemPhotos(photos: string[]): void {
    const data = {
      photos
    };
    this.modalService.open(
      LightningModalTypes.ModalFastTrackImagesComponent,
      { centered: true, size: 'xl' },
      data
    );
  }

  performSearch() {
    this.searchService.search_objects[ServiceType.FastTrack].chosen = true;
    this.searchService.determineHighestSearchPriority();
    this.searchService.startSearches();
  }

  addToCart(item: FastTrackQuote) {
    this.searchService.searches[ServiceType.FastTrack].addFastTrackToBasket(
      item,
      this.searchService.searches[ServiceType.FastTrack].getSearchQuery()
    );
    this.basketService.toggleMenu();
  }

  skipToResultContent() {
    const focusable = document
      .getElementById('parking')
      .querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    // @ts-ignore
    focusable[0].focus();
    return false;
  }

  openFasttrackDetails(item: FastTrackQuote) {
    this.modalService.open(
      LightningModalTypes.ModalFasttrackDetailsComponent,
      {
        centered: true
      },
      {
        item: item
      }
    );
  }
}
